import styles from './Switch.styles'
import { Theme } from '../constants';

export default function Switch ({isOn, name, handleToggleCb, switchUniqueId, onColor, customSwitchLabelStyle={}, customSwitchButtonStyle={}, title = ""}) {

    const switchOnColor = (onColor ? onColor : Theme.PRIMARY) 

    return (
        <>
            <input
                checked={isOn}
                name={name}
                onChange={handleToggleCb}        
                style={styles.switchCheckbox}
                id={switchUniqueId}
                type="checkbox"
            />
            <label
                title={title}
                style={{...styles.switchLabel, ...customSwitchLabelStyle, ...(isOn? {background: switchOnColor} : {}) }}
                htmlFor={switchUniqueId}
            >
                <span 
                    style={{...styles.switchButton, ...customSwitchButtonStyle, ...(isOn ? styles.switchButtonActive : "")}} 
                />
            </label>
        </>
    );
  };
  